import Vue from 'vue';
import { ValidationProvider, extend, localize } from 'vee-validate';
import {
  // eslint-disable-next-line camelcase
  required, email, regex, min, max_value, length,
} from 'vee-validate/dist/rules';
import ptBR from 'vee-validate/dist/locale/pt_BR.json';
import moment from 'moment/src/moment';
import 'moment/locale/pt-br';

moment.locale('pt_BR');

// Add rules
extend('required', required);
extend('email', email);
extend('length', length);
extend('regex', regex);
// extend('confirmed', confirmed);
extend('min', min);
extend('max_value', max_value);

extend('password', {
  params: [{ name: 'target', isTarget: true }],
  validate(value, { target }) {
    return value === target;
  },
  message: 'A senha e a confirmação da senha não são iguais',
});

extend('timeAfter', {
  computesRequired: true,
  params: ['target', 'field'],
  validate(value, { target }) {
    if (!value || !target) return true;
    const targetVal = moment(target, 'HH:mm');
    return moment(value, 'HH:mm').isAfter(targetVal);
  },
  message: () => 'O Horário deve ser superior ao inicial',
});

extend('cep', {
  computesRequired: true,
  validate(value) {
    if (!value) return true;
    return value.replace('-', '').length === 8;
  },
  message: () => 'CEP inválido!',
});

extend('token', {
  validate(value) {
    if (!value) return false;
    // eslint-disable-next-line no-undef
    return value.length === 1 && /^\d+$/.test(value); // parseInt(value, 0);
  },
  message: 'Token inválido',
});

localize('pt_BR', ptBR);

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
